const ExploreChartIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 28 28" fill="none" aria-hidden="true">
    <path d="M3.5 3.5V22.1667C3.5 22.7855 3.74583 23.379 4.18342 23.8166C4.621 24.2542 5.21449 24.5 5.83333 24.5H24.5" stroke="currentColor" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 19.8333V10.5" stroke="currentColor" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.1666 19.8334V5.83337" stroke="currentColor" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.33337 19.8334V16.3334" stroke="currentColor" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export default ExploreChartIcon
